module.exports = __webpack_public_path__ + "img/empty-products.11b1676d.svg";